import React from 'react';
import propTypes from 'prop-types';
import Modal from 'common/components/modals/Modal';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
import { editMembershipPods as managePath } from 'apps/account/paths';

export default class QuickShopSubscriberModal extends React.Component {
  static propTypes = {
    isOpen: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired,
  };

  redirectToEdit = () => {
    document.location.assign(managePath());
  };

  render() {
    const { isOpen, onClose } = this.props;

    return (
      <Modal
        className="QuickShopSubscriberModal"
        bodyClassName="QuickShopSubscriberModal__body"
        isOpen={isOpen}
        onRequestClose={onClose}
      >
        <TranslatedMessage
          id="cart.quick_shop.dual_cta.conflict_modal.text"
          className="QuickShopSubscriberModal__text"
        />
        <Button
          onClick={this.redirectToEdit}
          className="QuickShopSubscriberModal__button variant-actions-form__button subscribe"
        >
          <TranslatedMessage id="cart.quick_shop.dual_cta.conflict_modal.cta" />
        </Button>
      </Modal>
    );
  }
}
